var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 1.99414C12.9773 2.20469 12.4687 2.34688 11.9328 2.4125C12.4796 2.08438 12.9007 1.56484 13.0976 0.946875C12.5863 1.25039 12.0203 1.47187 11.416 1.58945C10.932 1.07266 10.2429 0.75 9.48276 0.75C8.01987 0.75 6.83589 1.93672 6.83589 3.39961C6.83589 3.60742 6.85776 3.80977 6.90425 4.00391C4.70308 3.89453 2.75073 2.83906 1.44644 1.23398C1.21948 1.625 1.08823 2.08164 1.08823 2.56562C1.08823 3.48437 1.55854 4.29648 2.26948 4.77227C1.83198 4.76133 1.42183 4.64102 1.06636 4.44141V4.47422C1.06636 5.75938 1.97964 6.82852 3.19097 7.07188C2.96948 7.13203 2.73433 7.16484 2.4937 7.16484C2.32417 7.16484 2.15737 7.14844 1.99605 7.11562C2.33237 8.16836 3.31128 8.93398 4.47065 8.95586C3.56558 9.6668 2.42261 10.0906 1.1812 10.0906C0.96792 10.0906 0.757373 10.077 0.549561 10.0523C1.71714 10.8125 3.10894 11.25 4.6019 11.25C9.4773 11.25 12.1406 7.21133 12.1406 3.70859C12.1406 3.59375 12.1378 3.47891 12.1324 3.3668C12.6492 2.99219 13.0976 2.52734 13.4531 1.99414Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bd7add1e458b5ff39c1683b1ebccc271.svg";
export { ForwardRef as ReactComponent };